import { render, staticRenderFns } from "./Blok4b.vue?vue&type=template&id=6fbb7d45"
import script from "./Blok4b.vue?vue&type=script&lang=js"
export * from "./Blok4b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports